import { render, staticRenderFns } from "./MatrixScaleConfigTableColumn.vue?vue&type=template&id=61d83029"
import script from "./MatrixScaleConfigTableColumn.vue?vue&type=script&lang=js"
export * from "./MatrixScaleConfigTableColumn.vue?vue&type=script&lang=js"
import style0 from "./MatrixScaleConfigTableColumn.vue?vue&type=style&index=0&id=61d83029&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports